import { Component, EventEmitter, Input, Output } from '@angular/core';
import { $auditFinding } from '../../../../../../../../shared/constants/audit-finding';
import { $scanIssues } from '../../../../../../../../shared/constants/scan-issues';
import {
  AdvancedSearchOperation,
  IAdvancedSearchRow,
} from '../../../../../../components/advanced-search/advanced-search.component';

@Component({
  selector: 'app-issues-advanced-search',
  templateUrl: './issues-advanced-search.component.html',
  styleUrls: ['./issues-advanced-search.component.scss'],
  standalone: false,
})
export class IssuesAdvancedSearchComponent {
  public fieldsToSearch: string[];
  public operations: AdvancedSearchOperation[];
  public defaultField: string;
  public defaultOperation: AdvancedSearchOperation;

  @Input()
  public initialRows: IAdvancedSearchRow[];
  @Output()
  public onApply: EventEmitter<IAdvancedSearchRow[]>;

  constructor() {
    this.fieldsToSearch = [$auditFinding.element, $auditFinding.elementReference, $scanIssues.url, $scanIssues.title];
    this.operations = Object.values(AdvancedSearchOperation);
    this.defaultField = $scanIssues.url;
    this.defaultOperation = AdvancedSearchOperation.contains;
    this.onApply = new EventEmitter<IAdvancedSearchRow[]>();
  }
}
